import React from 'react';

const ChessRook = ({ className = '', style = {} }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="none"
    className={className}
    style={style}
  >
    <rect x="5" y="19" width="14" height="2" rx="0.5"/>
    <rect x="6" y="16" width="12" height="2.5" rx="0.5"/>
    <polygon points="7,15.5 8,10.5 16,10.5 17,15.5"/>
    <rect x="8" y="7" width="8" height="3" rx="0.3"/>
    <rect x="8.5" y="4" width="2" height="3"/>
    <rect x="13.5" y="4" width="2" height="3"/>
  </svg>
);

export default ChessRook;
